import { createRef, useEffect, useState } from 'react';
import { DriverFinancialModel, DriverFinancialReportModel } from '../../../models/driverFinancial';
import axios from '../../../lib/axios';
import { FIND_MANY_DRIVER_FINANCIAL } from '../../../lib/endpoints/driverFinancial';
import { DEFAULT_ROWS_PER_PAGE } from '../../../config-global';
import { convertDateStringToNormalString } from '../../../utils/convertDateFormat';
import moment from 'moment';
import { OrderModel } from '../../../models/order';
import { numberFormat } from '../../../utils/nunberFormat';
import { totalDistance } from '../../../utils/sumTotalDistance';

const useRiderReportController = () => {
  const [dataRiderReport, setDateRiderReport] = useState<DriverFinancialModel[]>([]);
  const [selectedData, setSelectedData] = useState<DriverFinancialModel[]>([]);
  const [moneyRider, setMoneyRider] = useState<number>(null!);
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [openMenu, setOpenMenu] = useState(null);
  const [selectedId, setSelectedId] = useState<string>(null!);
  const [openForm, setOpenForm] = useState<boolean>(false);
  const [date, setDate] = useState<any>(null!);
  const [searchValue, setSearchValue] = useState<string>('');
  const [isInit, setIsInit] = useState<boolean>(false);

  const buttonExportCsv = createRef<any>();

  //-------------- fetchData--------------//
  const handleFetchRiderReport = async () => {
    try {
      const responseData = await axios.post(FIND_MANY_DRIVER_FINANCIAL, {
        filter: {
          isPaidStatus: true,
          clear: true,
        },
      });
      setDateRiderReport(
        responseData?.data?.data.filter(
          (item: DriverFinancialModel) => item?.clear === true && item?.isPaidStatus === true
        )
      );
      setMoneyRider(responseData?.data?.AllTotalMoney);
    } catch (err) {
      // console.log(err);
    }
  };

  const handleGetData = async () => {
    try {
      setLoadingData(true);
      await handleFetchRiderReport();
    } catch (err) {
      // console.log(err);
    } finally {
      setLoadingData(false);
    }
  };

  //---------------End ------------------//

  //--------------Function --------------//

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleOpenMenu = (event: any, getId: string) => {
    setOpenMenu(event.currentTarget);
    setSelectedId(getId);
  };

  const handleOpenForm = () => {
    setOpenForm(true);
    const getCurrentData: DriverFinancialModel = dataRiderReport.filter(
      (item) => item?.id === selectedId
    )[0];
    const getData = dataRiderReport?.filter(
      (item: DriverFinancialModel) => item?.rider?.id === getCurrentData?.rider?.id
    );
    setSelectedData(getData);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    setOpenMenu(null);
  };

  const handleCloseMenu = () => {
    setOpenMenu(null);
  };

  const handleSearch = (e: any) => {
    setSearchValue(e.target.value);
  };

  const handleChangeDate = (event: any) => {
    setDate(event.target.value);
    setPage(1);
  };

  //--------------End -------------------//

  //-------------- Filter ---------------//

  const filterDataByDate = dataRiderReport.filter((data: DriverFinancialModel) => {
    // if (date) {
    //   return (
    //     convertDateStringToNormalString(data?.updatedAt) ===
    //     moment(new Date(date)).format('DD/MM/YYYY')
    //   );
    // }
    return true;
  });

  const filterData = filterDataByDate?.filter((item: DriverFinancialModel) =>
    item?.rider?.username?.toLowerCase()?.includes(searchValue.toLocaleLowerCase())
  );

  const handleGroupData = (): DriverFinancialReportModel[] => {
    let result: DriverFinancialReportModel[] = [];

    for (let i: number = 0; i < filterData.length; i++) {
      const existingIndex: number = result.findIndex(
        (item) => item?.rider?.id === filterData[i]?.rider?.id
      );

      const orderCash = filterData[i]?.ordersCash?.orders?.map((item) => item?.distance) || [];
      const orderOnePay = filterData[i]?.ordersOnePay?.orders?.map((item) => item?.distance) || [];
      const orderReturn = filterData[i]?.ordersReturn?.orders?.map((item) => item?.distance) || [];

      const distance = totalDistance(orderCash, orderOnePay, orderReturn);

      const ordersCashLength = filterData[i]?.ordersCash?.orders?.length || 0;
      const ordersOnePayLength = filterData[i]?.ordersOnePay?.orders?.length || 0;
      const ordersReturnLength = filterData[i]?.ordersReturn?.orders?.length || 0;
      const orderAmount = ordersCashLength + ordersOnePayLength + ordersReturnLength;

      if (existingIndex !== -1) {
        result[existingIndex] = {
          ...result[existingIndex],
          totalRound: result[existingIndex]?.totalRound + 1,
          orderAmount: (result[existingIndex]?.orderAmount || 0) + orderAmount,
          total: (result[existingIndex]?.total || 0) + (filterData[i]?.totalMoney || 0),
          rider: {
            ...result[existingIndex]?.rider,
            totalMoney:
              (result[existingIndex]?.rider?.totalMoney || 0) +
              (filterData[i]?.totalMoneyRiderGot || 0),
          },
          totalDistanceRiderGot: (result[existingIndex]?.totalDistanceRiderGot || 0) + distance,
        };
      } else {
        result.push({
          id: filterData[i]?.id,
          rider: {
            id: filterData[i]?.rider?.id,
            username: filterData[i]?.rider?.username,
            type: filterData[i]?.rider?.type,
            totalMoney: filterData[i]?.totalMoneyRiderGot || 0,
          },
          totalRound: 1,
          orderAmount: orderAmount,
          total: filterData[i]?.totalMoney || 0,
          totalDistanceRiderGot: distance,
        });
      }
    }

    return result;
  };

  const getExportCsvData = handleGroupData()?.map((item) => {
    return {
      username: item?.rider?.username,
      type: item?.rider?.type,
      totalRound: item?.totalRound,
      orderAmount: item?.orderAmount,
      totalDistanceRiderGot: item?.totalDistanceRiderGot.toFixed(2),
      totalMoney: numberFormat(item?.rider?.totalMoney),
      total: numberFormat(item?.total),
    };
  });

  const rows: DriverFinancialReportModel[] = handleGroupData().slice(
    (page - 1) * DEFAULT_ROWS_PER_PAGE,
    page * DEFAULT_ROWS_PER_PAGE + DEFAULT_ROWS_PER_PAGE
  );

  const countPagination = Math.ceil(filterData.length / DEFAULT_ROWS_PER_PAGE);
  const isSearchNotFound: boolean = !filterData.length && !!searchValue;

  const TotalMoneyRiderGot = handleGroupData()
    ?.map((item: DriverFinancialReportModel) => item?.rider?.totalMoney)
    .reduce((accumulator: number | undefined, currentValue: number | undefined) => {
      return (accumulator || 0) + (currentValue || 0);
    }, 0);

  //--------------- End -----------------//

  //-------------useEffect --------------//
  useEffect(() => {
    handleGetData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //--------------End ------------------//
  return {
    loadingData,
    moneyRider,
    rows,
    handleChangePage,
    page,
    countPagination,
    handleOpenMenu,
    handleCloseMenu,
    openMenu,
    handleCloseForm,
    handleOpenForm,
    openForm,
    selectedData,
    searchValue,
    handleSearch,
    isSearchNotFound,
    handleChangeDate,
    date,
    getExportCsvData,
    buttonExportCsv,
    TotalMoneyRiderGot,
    handleGroupData,
  };
};
export default useRiderReportController;
